"use client";

import {useLocale, useTranslations} from "next-intl";

import {Link, usePathname} from "@/i18n/navigation";

export function LocaleSwitcher() {
  const t = useTranslations("LocaleSwitcher");
  const locale = useLocale();
  const pathname = usePathname();

  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-zinc-300 bg-zinc-100/90 p-1 dark:border-zinc-700 dark:bg-zinc-900/80">
      <Link
        href={pathname}
        locale="en"
        className={`rounded-full px-2 py-0.5 text-xs transition ${locale === "en" ? "bg-zinc-200 text-zinc-900 dark:bg-zinc-700 dark:text-zinc-100" : "text-zinc-600 hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-200"}`}
      >
        {t("en")}
      </Link>
      <Link
        href={pathname}
        locale="zh-TW"
        className={`rounded-full px-2 py-0.5 text-xs transition ${locale === "zh-TW" ? "bg-zinc-200 text-zinc-900 dark:bg-zinc-700 dark:text-zinc-100" : "text-zinc-600 hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-200"}`}
      >
        {t("zhTW")}
      </Link>
    </div>
  );
}
